var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6219 10.8266L14.8359 14.0391C15.0547 14.2594 15.0547 14.6156 14.8375 14.8359C14.7266 14.9453 14.5844 15 14.4391 15C14.2937 15 14.15 14.9453 14.0406 14.8359L10.8266 11.6219C9.7875 12.4828 8.45469 13 7 13C3.68594 13 1 10.3141 1 7C1 3.68594 3.68594 1 7 1C10.3141 1 13 3.68594 13 7C13 8.45469 12.4828 9.7875 11.6219 10.8266ZM7 11.875C7.65938 11.875 8.29688 11.7469 8.89687 11.4922C9.47812 11.2469 9.99844 10.8953 10.4469 10.4469C10.8953 9.99844 11.2469 9.47656 11.4922 8.89687C11.7469 8.29688 11.875 7.65938 11.875 7C11.875 6.34062 11.7469 5.70312 11.4922 5.10313C11.2469 4.52344 10.8953 4.00156 10.4469 3.55312C9.99844 3.10469 9.47656 2.75312 8.89687 2.50781C8.29688 2.25312 7.65938 2.125 7 2.125C6.34062 2.125 5.70312 2.25312 5.10313 2.50781C4.52344 2.75312 4.00156 3.10469 3.55312 3.55312C3.10469 4.00156 2.75312 4.52344 2.50781 5.10313C2.25312 5.70312 2.125 6.34062 2.125 7C2.125 7.65938 2.25312 8.29688 2.50781 8.89687C2.75312 9.47656 3.10469 9.99844 3.55312 10.4469C4.00156 10.8953 4.52344 11.2469 5.10313 11.4922C5.70312 11.7469 6.34062 11.875 7 11.875Z",
    fill: "#626262"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.2da2104b6f2002b23b5736cea1674c9b.svg";
export { ForwardRef as ReactComponent };